import { useRef } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { DemoShaderMaterial } from "../shaders/skybox";

export function DemoSkybox() {
  const materialRef = useRef();

  useFrame((state) => {
    if (materialRef.current) {
      materialRef.current.uniforms.time.value = state.clock.elapsedTime;
    }
  });

  return (
    <mesh>
      <sphereGeometry args={[80, 64, 64]} />
      <shaderMaterial
        ref={materialRef}
        args={[DemoShaderMaterial]}
        side={THREE.BackSide}
      />
    </mesh>
  );
}
